const folders = {
  folders: "Папки",
  createFolder: "Создать папку",
  folderName: "Название папки",
  folderIcon: "Иконка",
  gridSize: "Размер сетки",
  columns: "Столбцы",
  rows: "Строки",
  items: "элементов",
  pin: "Закрепить",
  unpin: "Открепить",
  addWidget: "Добавить виджет",
  addShortcut: "Добавить ярлык",
  addAction: "Добавить действие",
  widgetsTab: "Виджеты",
  actionsTab: "Действия",
  noItems: "Папка пуста",
  editFolder: "Редактировать папку",
  deleteFolder: "Удалить папку",
  bookmarksTab: "Закладки",
  addBookmark: "Добавить",
  bookmarkName: "Название закладки",
  bookmarkUrl: "URL или /dashboard/...",
  bookmarkIcon: "Иконка",
  addCurrentPage: "Текущая страница",
} as const;
export default folders;
